import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-features-card',
  templateUrl: './features-card.component.html',
  styleUrls: ['./features-card.component.scss']
})
export class FeaturesCardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
